import React from "react";
import { StyleSheet } from "react-native";

import { Box, Label } from "../../../../../../../../mads";

interface LabelledContentProps {
  label: string;
}

const ViewJobLabelledContent: React.FC<React.PropsWithChildren<LabelledContentProps>> = ({
  label,
  children,
}) => (
  <Box sx={styles.viewJobLabelledContentContainer}>
    <Label text={label} />
    {children}
  </Box>
);

const styles = StyleSheet.create({
  viewJobLabelledContentContainer: {
    marginTop: 16,
  },
  label: {
    fontSize: 2,
  },
});

export default ViewJobLabelledContent;
